var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"page-title"},[_vm._v("My profile")]),_c('div',{staticClass:"profile-and-event-container"},[_c('ProfileForm'),_c('v-divider'),_c('ProfileExtraInfo')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }